import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Modal, Text } from '@maui/elements'
import MitreAttackValidationSection from '../charts/MitreAttackChart/MitreAttackValidationSection'
import { Remarkable } from 'remarkable'

const parseDescription = (description) => {
  const mdParser = new Remarkable()
  const parsedDescription = mdParser.render(description)
  const formattedDescription = parsedDescription.replace(/<a/g, '<a style="color: #98bef6"')
  return formattedDescription
}
function MitreAttackModal({ ...modalProps }) {
  const { identifier, name, description, ...restModalProps } = modalProps

  const Title = () => (
    <Text
      color='colorTextMain'
      backgroundImage='url(../../../../icons/mitre-attack-dark.png)'
      backgroundRepeat='no-repeat'
      backgroundSize='20px'
      backgroundPosition='0 0.5rem'
      paddingLeft='2.5rem'
      fontSize='textHeading2FontSize'
      lineHeight='textHeading2LineHeight'
    >
      {name} ({identifier})
    </Text>
  )

  const parsedDescription = parseDescription(description)

  return (
    <Modal
      {...restModalProps}
      ariaHideApp={false}
      color='colorTextMain'
    >
      <Modal.Header onClose={restModalProps.onClose}>
        <Modal.Title><Title /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box
          className='MarkdownContainer'
          variant='body2'
          color='colorTextMain'
          dangerouslySetInnerHTML={{ __html: parsedDescription }}
        />
        <MitreAttackValidationSection techniqueId={identifier} />
      </Modal.Body>
      <Modal.Footer style={{ border: '0', justifyContent: 'flex-start' }}>
        <Button variant="secondary" onClick={restModalProps.onClose}>Done</Button>
      </Modal.Footer>
    </Modal>
  )
}

MitreAttackModal.propTypes = {
  modalOpen: PropTypes.bool,
  modalProps: PropTypes.object,
  setModalOpen: PropTypes.func,
}

export default MitreAttackModal
